import { css } from '@emotion/react';
import { Colors, media } from '@dizraptors/ui-kit';

export const globalStyles = css`
  ::selection {
    color: ${Colors.text.inverse};
    background: ${Colors.text.primary};
  }

  :root {
    --header-height: 9rem;
    --footer-margin-top: 6rem;

    @media ${media.phonablet} {
      --header-height: 5rem;
      --footer-margin-top: 4rem;
    }
  }

  #___gatsby {
    min-height: 100%;
  }

  #___gatsby,
  #gatsby-focus-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  img {
    user-select: none;
  }
`;
